import { gql } from '@apollo/client'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Input, Label, Table } from 'reactstrap'
import { CUSTOM_SELECT_LIST_QUERY, VALUATION_PROJECTION_BY_CATEGORY_REPORT_QUERY } from '../../../graphql'
import { enterKeyHandler, handleGraphQLErrors, makeInteger } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import Spinner from '../../Spinner/Spinner'
import '../Custom.css'
import { getData, stringifyInputs } from '../CustomUtils'
import FormSubmitButton from '../FormSubmitButton'
import ReportHeading from '../ReportHeading'

export const CUSTOM_SELECT_LIST = gql(CUSTOM_SELECT_LIST_QUERY)
export const VALUATION_PROJECTION_BY_CATEGORY_REPORT = gql(VALUATION_PROJECTION_BY_CATEGORY_REPORT_QUERY)

export default function ValuationProjectionByCategory({ location }) {
  console.log('ValuationProjectionByCategory rendered: ', location)

  const init = {
    settlementGroups: [],
    categories: [],
    values: []
  }

  const [settlementGroups, setSettlementGroups] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [results, setResults] = useState()
  let [values] = useState()
  const navigate = useNavigate()
  const { inputs, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  useEffect(() => {
    async function getSettlementGroups () {
      try {
        let { data, errors } = await window.apolloClient.query({ query: CUSTOM_SELECT_LIST, variables: { modelName: 'BosSci', entityName: 'settlement_group' }, fetchPolicy: 'cache-first' })
        if (data.customSelectList) {
          setSettlementGroups(data.customSelectList)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        console.log(err)
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!settlementGroups) {
      getSettlementGroups()
    }
    if (!results) {
      location.search='?inputs={"settlementGroups":[],"categories":[],"values":[]}'
      getData(location, VALUATION_PROJECTION_BY_CATEGORY_REPORT, 'valuationProjectionByCategoryReport', setResults, setGraphQLErrors)
    } else {
      getData(location, VALUATION_PROJECTION_BY_CATEGORY_REPORT, 'valuationProjectionByCategoryReport', setResults, setGraphQLErrors)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, settlementGroups])

  async function submitSearch() {
    console.log('ValuationProjectionByCategory.submitSearch', inputs)
    for (let i = 0; i < results.reportData.length; i++) {
      inputs.categories.push(results.reportData[i][0])
    }
    inputs.values = values
    let queryString = `/custom/reports.category_valuation_projection?inputs=${stringifyInputs(inputs)}`
    navigate(queryString)
  }

  function handleCheckbox(e) {
    if (e.target.checked === true) {
      inputs.settlementGroups.push(e.target.name)
    } else {
      let index = inputs.settlementGroups.indexOf(e.target.name)
      inputs.settlementGroups.splice(index, 1)
    }
  }

  function handleValues(e) {
    values[e.target.name] = e.target.value
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!settlementGroups || !results) {
    return <Spinner />
  } else {
    const initValues = Array(results.reportData.length)
    for (let i = 0; i < initValues.length; i++) {
      initValues[i] = results.reportData[i][3]
    }
    values = initValues

    let checkboxGrid = []
    for (let i = 0; i < settlementGroups.length; i++) {
      let checkboxRow = []
      for (let j = 0; j < 5; j++) {
        if (settlementGroups[i])
          checkboxRow.push(<td style={{border: 'none'}} key={i}><Input className="custom-checkbox" type="checkbox" name={settlementGroups[i].id} onChange={(e) => handleCheckbox(e)} /> {settlementGroups[i].name}</td>)
        i++
      }
      checkboxGrid.push(<tr key={i}>{checkboxRow}</tr>)
    }

    const formatter = new Intl.NumberFormat()
    let totals = [0,0,0]
    let resultsGrid = []
    for (let i = 0; i < results.reportData.length; i++) {
      let resultsRow = []
      resultsRow.push(<td><b>{results.reportData[i][1]}</b></td>)
      resultsRow.push(<td style={{textAlign:'right'}}>{formatter.format(results.reportData[i][2])}</td>)
      resultsRow.push(<td align='right'>$<Input style={{textAlign: 'right'}} className="custom-input" type='number' name={i} onChange={(e) => handleValues(e)} defaultValue={results.reportData[i][3]} /></td>)
      resultsRow.push(<td style={{textAlign:'right'}}>${formatter.format(results.reportData[i][4])}</td>)
      resultsGrid.push(<tr key={i}>{resultsRow}</tr>)
      totals[0] += makeInteger(results.reportData[i][2])
      totals[1] += makeInteger(results.reportData[i][3])
      totals[2] += makeInteger(results.reportData[i][4])
    }

    return (
      <div className="custom-scroll">
        <form className="form" onSubmit={handleSubmit}>
          <div>
            <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
              <ReportHeading title='Valuation Projection Report' showReportDate={false} widths={['0%', '100%', '0%']} />
              <tbody>
                <tr><td colSpan='4'>
                  <Table>
                    <tbody>
                      <tr><td style={{border: 'none'}}><Label><b>Settlement Groups</b></Label></td></tr>
                      {checkboxGrid}
                    </tbody>
                  </Table>
                </td>
                </tr>
                <tr><td><b>Case Category</b></td><td><b>Number of Cases</b></td><td><b>Settlement Authority on a per case basis</b></td><td><b>Total Settlement Authority</b></td></tr>
                {resultsGrid}
                <tr><td align='right'><b>Totals</b></td>
                  <td align='right'>{formatter.format(totals[0])}</td>
                  <td align='right'>${formatter.format(totals[1])}</td>
                  <td align='right'>${formatter.format(totals[2])}</td></tr>
              </tbody>
            </Table>
          </div>
          <FormSubmitButton />
        </form>
      </div>
    )
  }
}

